<main class="chat-auth">
  <div class="card chat-auth__card mb-0">
    <div class="card-body p-4">
      <div class="text-center mb-4">
        <div class="auth-brand mb-0">
          <img src="assets/images/logo-dark.svg" class="logo-dark chat-auth__logo mx-auto" alt="Trendmulti" />
          <img src="assets/images/logo.svg" class="logo-light chat-auth__logo mx-auto" alt="Trendmulti" />
        </div>
        <h4 class="mt-3 mb-1">{{ 'chatApp.signIn.title' | translate }}</h4>
        <p class="text-muted mb-0">{{ 'chatApp.signIn.subtitle' | translate }}</p>
      </div>

      @if (reasonKey) {
        <div class="alert alert-warning py-2" role="alert">
          <p class="mb-0"><i class="ri-information-line me-1"></i>{{ reasonKey | translate }}</p>
        </div>
      }

      @if (errorMessage) {
        <div class="alert alert-danger py-2" role="alert">
          <p class="mb-0"><i class="ri-error-warning-line me-1"></i>{{ errorMessage }}</p>
        </div>
      }

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="mb-3">
          <label for="chatSignInEmail" class="form-label">{{ 'chatApp.signIn.email' | translate }}</label>
          <input
            id="chatSignInEmail"
            type="email"
            class="form-control"
            formControlName="email"
            autocomplete="username"
            inputmode="email"
            [class.is-invalid]="isInvalid('email')"
          />
          @if (isInvalid('email')) {
            <div class="invalid-feedback">{{ 'chatApp.signIn.emailInvalid' | translate }}</div>
          }
        </div>

        <div class="mb-3">
          <label for="chatSignInPassword" class="form-label">{{ 'chatApp.signIn.password' | translate }}</label>
          <div class="input-group" [class.has-validation]="isInvalid('password')">
            <input
              id="chatSignInPassword"
              class="form-control"
              formControlName="password"
              autocomplete="current-password"
              [type]="passwordHidden ? 'password' : 'text'"
              [class.is-invalid]="isInvalid('password')"
            />
            <button
              type="button"
              class="btn btn-light"
              (click)="passwordHidden = !passwordHidden"
              [attr.aria-label]="(passwordHidden ? 'chatApp.signIn.showPassword' : 'chatApp.signIn.hidePassword') | translate"
            >
              <i [class]="passwordHidden ? 'ri-eye-line' : 'ri-eye-off-line'" aria-hidden="true"></i>
            </button>
            @if (isInvalid('password')) {
              <div class="invalid-feedback">{{ 'chatApp.signIn.passwordInvalid' | translate }}</div>
            }
          </div>
        </div>

        <div class="d-flex justify-content-center mb-3">
          <ngx-recaptcha2
            #captchaElem
            [siteKey]="recaptchaSiteKey"
            formControlName="recaptcha"
            (expire)="onCaptchaExpire()"
          ></ngx-recaptcha2>
        </div>

        <button type="submit" class="btn btn-primary w-100" [disabled]="submitting">
          @if (submitting) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          }
          {{ 'chatApp.signIn.submit' | translate }}
        </button>
      </form>

      <div class="d-flex flex-column align-items-center gap-1 mt-3">
        <a class="small" [href]="productLoginUrl" target="_blank" rel="noopener">
          {{ 'chatApp.signIn.forgotPassword' | translate }}
        </a>
        <a class="small text-muted" [href]="productUrl">
          <i class="ri-arrow-left-line me-1" aria-hidden="true"></i>{{ 'chatApp.common.backToProduct' | translate }}
        </a>
      </div>
    </div>
  </div>
</main>
